import src from "IMAGE";
export default { src, width: 1114, height: 1114, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAN0lEQVR42o1PyQ0AMAgigf1nbmtSw6NV+XiAB8AGSUiK6DkumYUh+0f9Q3Cvad/SC0Ynyic7mwuP4gEVDgBu0AAAAABJRU5ErkJggg=="};
